import { jsx as l, jsxs as e } from "react/jsx-runtime";
function m(a) {
  return /* @__PURE__ */ l("svg", { height: "1em", viewBox: "0 0 24 24", width: "1em", ...a, children: /* @__PURE__ */ e("g", { fill: "none", fillRule: "evenodd", children: [
    /* @__PURE__ */ l("path", { d: "M4 4h16v16H4z" }),
    /* @__PURE__ */ l(
      "path",
      {
        d: "M12 4c4.41 0 8 3.59 8 8s-3.59 8-8 8-8-3.59-8-8 3.59-8 8-8zm1.768 11.5h-3.533l-1.002 1.203.63 1.964a6.99 6.99 0 003.916.104l.974-2.105-.985-1.167zm3.374 1.245l-1.456.287-.572 1.237a7.036 7.036 0 002.028-1.524zm-8.5 1.396l-.343-1.07-1.19-.067c.456.445.971.828 1.533 1.137zm-1.914-7.3l-1.695 1.842a6.962 6.962 0 001.193 3.27l2.228.121.98-1.177-1.164-3.303-1.542-.754zm10.556 0l-1.54.754-1.177 3.301.967 1.146 2.498-.493a6.944 6.944 0 00.935-2.866l-1.683-1.843zm-5.276-1.417l-2.74 1.996 1.086 3.08h3.293l1.1-3.08-2.74-1.996zm-6.962 1.767l1.021-1.11-.282-1.3a6.937 6.937 0 00-.739 2.41zM18.224 8.8l-.278 1.284 1.007 1.098a6.944 6.944 0 00-.729-2.382zM14.57 5.49L12.508 6.6v1.95l2.885 2.104 1.572-.77.492-2.264a7.036 7.036 0 00-2.887-2.131zM6.555 7.606l.492 2.277 1.576.77 2.885-2.103V6.596L9.445 5.483a7.027 7.027 0 00-2.89 2.123zM12 5a6.99 6.99 0 00-1.165.097l1.175.635 1.174-.632c-.385-.066-.78-.1-1.184-.1z",
        fill: "currentColor"
      }
    )
  ] }) });
}
export {
  m as default
};
